var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage-header"},[_c('user-info'),_c('md-row',{staticClass:"homepage-bottom",attrs:{"gutter":16}},[_c('md-col',{staticClass:"homepage-left",attrs:{"span":24}},[_c('my-agent',{staticClass:"my-agent"}),_c('notice',{staticClass:"notice"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }